import { render, staticRenderFns } from "./ItTermsOfUse.vue?vue&type=template&id=e9ae06c8&scoped=true"
import script from "./ItTermsOfUse.vue?vue&type=script&lang=js"
export * from "./ItTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e9ae06c8",
  null
  ,true
)

export default component.exports